'use client';
import React from 'react';
import { ErrorBoundary } from '@benzinga/core-ui';
import { FreestarAd, TaboolaPlacement } from '@benzinga/ads';

import { QuoteCard, SidebarList } from '../../../_components/markets';
import type { SidebarQuote } from '../data';

interface ReportsIndexSidebarProps {
  trendingQuotes: SidebarQuote[];
  topMovers: SidebarQuote[];
}

export const ReportsIndexSidebar = ({ trendingQuotes = [], topMovers = [] }: Partial<ReportsIndexSidebarProps>) => {
  const [pageUrl, setPageUrl] = React.useState('');

  React.useEffect(() => {
    setPageUrl(window.location.href);
  }, []);

  return (
    <>
      <ErrorBoundary name="ReportsIndexSidebar">
        <div className="space-y-6 pt-6">
          <SidebarList showViewMore={false} title="Trending Tickers">
            {trendingQuotes.length > 0 ? (
              trendingQuotes.map((ticker, i) => (
                <QuoteCard
                  href={`/quote/${ticker.symbol}/report`}
                  key={'trending-' + i}
                  showLogo
                  ticker={ticker}
                  variant="list"
                />
              ))
            ) : (
              <p className="text-xs text-slate-400 p-2">Market data unavailable</p>
            )}
          </SidebarList>

          <SidebarList showViewMore={false} title="Stocks Moving Today">
            {topMovers.length > 0 ? (
              topMovers.map((ticker, i) => (
                <QuoteCard
                  href={`/quote/${ticker.symbol}/report`}
                  key={'mover-' + i}
                  showLogo
                  ticker={ticker}
                  variant="list"
                />
              ))
            ) : (
              <p className="text-xs text-slate-400 p-2">Market data unavailable</p>
            )}
          </SidebarList>

          <React.Suspense fallback={<div />}>
            <FreestarAd className="w-[300px] overflow-hidden" placement="sidebar_1" />
          </React.Suspense>

          {pageUrl ? (
            <TaboolaPlacement
              id="right-rail-thumbnails"
              mode="thumbnails-right"
              placement="Right Rail Thumbnails"
              settings={{ article: 'auto', target_type: 'mix', url: pageUrl }}
              shouldFlush={false}
              url={pageUrl}
              vizSensor={false}
            />
          ) : null}

          <React.Suspense fallback={<div />}>
            <FreestarAd className="w-[300px] overflow-hidden" placement="sidebar_2" />
          </React.Suspense>
        </div>
      </ErrorBoundary>
    </>
  );
};
